<template lang='pug'>
v-navigation-drawer(
  v-model="is_show_drawer"
  fixed
  right
  temporary
  touchless
  :width="is_desktop() ? '85%' : '100%'"
  :overlay-opacity="0.7"
  height="85%"
  :z-index="998 + drawer_stack.length"
  class="side-drawer"
)
  v-overlay(
    :value='is_show_loading'
    absolute
    opacity='0.8'
    z-index='6'
  )
    v-progress-circular(indeterminate color='primary')
  .drawer-container
    v-toolbar.drawer-header(flat dense color="secondary")
      v-toolbar-title
        v-btn.mr-2.back-button(
          v-if="drawer_stack.length > 0"
          @click="go_back"
          :title="'返回上一層 (層級: ' + drawer_stack.length + ')'"
          small
        )
          span ◀
        .title-wrapper(:class="{ 'title-scrollable': !is_desktop(), 'with-back-btn': drawer_stack.length > 0, 'no-date-picker': !enable_date_picker }")
          span.title-text {{ display_title }}

        v-chip.display-chip.ml-2(
          v-if="date_range_display && is_desktop()"
          :color="period_chip_color"
          text-color="white"
          :clickable="enable_date_picker"
          @click="open_period_picker"
        ) {{ date_range_display }}

        v-chip.display-chip.ml-2.mobile-date-chip(
          v-if="!is_desktop() && enable_date_picker"
          @click="open_period_picker"
          :color="period_chip_color"
          text-color="white"
        )
          v-icon(size="24") date_range

    .drawer-content(ref='drawer_content')
      component(ref="ref_component" :is="get_component" @hook:mounted="on_component_mounted")

    custom_period_picker(
      v-if="enable_date_picker"
      v-model="period_picker_modal"
      :support_period_modes="picker_state.support_period_modes"
      :initial_mode="picker_state.current_mode"
      :initial_daily_range="picker_state.daily_range"
      :initial_hourly_date="picker_state.hourly_date"
      :initial_monthly_range="picker_state.monthly_range"
      @confirm="on_period_confirm"
    )

</template>

<script>
import loading_mixin from '@/components/mixins/loading_mixin';
import desktop_mixin from '@/components/mixins/desktop_mixin';
import custom_period_picker from '@/components/v_row/custom_period_picker.vue';
import {
  PERIOD_MODE_DAILY,
  PERIOD_MODE_HOURLY,
  PERIOD_MODE_MONTHLY,
  PERIOD_CHIP_COLOR,
} from '@/assets/constant/period_mode';

const component_list = {
  wg_site_compare: () => import('@/components/widget/wg_site_compare'),
  wg_site_outline: () => import('@/components/widget/wg_site_outline'),
  wg_member_level_outline: () => import('@/components/widget/wg_member_level_outline'),
  wg_member_prank_outline: () => import('@/components/widget/wg_member_prank_outline'),
  wg_member_reg_age_outline: () => import('@/components/widget/wg_member_reg_age_outline'),
  wg_member_returning_outline: () => import('@/components/widget/wg_member_returning_outline'),
  wg_member_tag_outline: () => import('@/components/widget/wg_member_tag_outline'),
  wg_member_search: () => import('@/components/widget/wg_member_search'),
  wg_member_one_outline: () => import('@/components/widget/wg_member_one_outline'),
  wg_promo_compare: () => import('@/components/widget/wg_promo_compare'),
  wg_promo_binding_compare: () => import('@/components/widget/wg_promo_binding_compare'),
  wg_game_item_compare: () => import('@/components/widget/wg_game_item_compare'),
  wg_game_compare: () => import('@/components/widget/wg_game_compare'),
  wg_game_retention_compare: () => import('@/components/widget/wg_game_retention_compare'),
  wg_game_theme_compare: () => import('@/components/widget/wg_game_theme_compare'),
  wg_game_theme_outline: () => import('@/components/widget/wg_game_theme_outline'),
  wg_trans_tppp_compare: () => import('@/components/widget/wg_trans_tppp_compare'),
  wg_network_http_compare: () => import('@/components/widget/wg_network_http_compare'),
  wg_network_probe_compare: () => import('@/components/widget/wg_network_probe_compare'),
};

// 定義哪些組件需要日期選擇器（可以點擊更改日期）
const date_picker_enabled_components = [
  'wg_member_one_outline',
];

const date_picker_exclude_components = [
  'wg_member_level_outline',
  'wg_member_prank_outline',
  'wg_member_reg_age_outline',
  'wg_member_returning_outline',
  'wg_member_tag_outline',
];

export default {
  mixins: [loading_mixin, desktop_mixin],
  components: {
    custom_period_picker,
  },
  data() {
    return {
      is_show_drawer: false,
      title_suffix: '',
      widget_menu_name: '',
      date_range_display: '',
      component_name: null,
      component_func: null,
      pending_params: null,
      enable_date_picker: false,
      period_picker_modal: false,
      current_period_mode: PERIOD_MODE_DAILY,
      picker_state: {
        support_period_modes: [PERIOD_MODE_DAILY],
        current_mode: PERIOD_MODE_DAILY,
        daily_range: [],
        hourly_date: '',
        monthly_range: [],
      },
      drawer_stack: [],
    };
  },
  computed: {
    get_component() {
      return this.component_name ? component_list[this.component_name] : null;
    },
    display_title() {
      return this.widget_menu_name + (this.title_suffix ? ` - ${this.title_suffix}` : '');
    },
    period_chip_color() {
      if (!this.enable_date_picker) return 'grey';
      return PERIOD_CHIP_COLOR[this.current_period_mode] || 'primary';
    },
  },
  watch: {
    is_show_drawer(val) {
      if (val) {
        this.$refs.drawer_content.scrollTop = 0;
      } else {
        this.clear_drawer_stack();
      }
    }
  },
  methods: {
    clear_drawer_stack() {
      this.drawer_stack = [];
      this.title_suffix = '';
      this.widget_menu_name = '';
      this.component_name = null;
      this.component_func = null;
      this.pending_params = null;
      this.enable_date_picker = false;
      this.date_range_display = '';
    },

    build_period_text(mode, p) {
      if (!p) return '';
      if (mode === PERIOD_MODE_HOURLY) return p.p_rpt_date_start || '';
      if (mode === PERIOD_MODE_MONTHLY && p.p_rpt_month_start && p.p_rpt_month_end) {
        return `${p.p_rpt_month_start} ~ ${p.p_rpt_month_end}`;
      }
      if (p.p_rpt_date_start && p.p_rpt_date_end) {
        return `${p.p_rpt_date_start} ~ ${p.p_rpt_date_end}`;
      }
      return '';
    },

    sync_period_display() {
      const widget = this.$refs.ref_component;
      const mode = widget?.current_period_mode || PERIOD_MODE_DAILY;
      const params = widget?.last_req_params || this.pending_params;
      this.current_period_mode = mode;
      this.date_range_display = this.build_period_text(mode, params);
    },

    open_period_picker() {
      const state = this.$refs.ref_component?.get_period_picker_state?.();
      if (state) this.picker_state = state;
      this.period_picker_modal = true;
    },

    async on_period_confirm(payload) {
      const widget = this.$refs.ref_component;
      if (widget?.apply_period_picker_value) {
        await this.with_loading(() => widget.apply_period_picker_value(payload));
      }
      this.sync_period_display();
    },

    go_back() {
      if (this.drawer_stack.length > 0) {
        const prev_drawer = this.drawer_stack.pop();

        this.title_suffix = prev_drawer.title_suffix;
        this.widget_menu_name = prev_drawer.widget_menu_name;
        this.component_name = prev_drawer.component_name;
        this.component_func = prev_drawer.component_func;
        this.pending_params = prev_drawer.pending_params;
        this.enable_date_picker = prev_drawer.enable_date_picker;
        this.date_range_display = prev_drawer.date_range_display;
        this.current_period_mode = prev_drawer.current_period_mode || PERIOD_MODE_DAILY;

        this.$nextTick(() => {
          this.trigger_component();
        });
      } else {
        this.is_show_drawer = false;
      }
    },

    on_component_mounted() {
      this.widget_menu_name = this.$refs.ref_component?.menu_name || '';
      this.trigger_component();
    },

    async trigger_drawer({ component_name, component_func, component_params, title_suffix }) {
      if (this.component_name) {
        this.drawer_stack.push({
          title_suffix: this.title_suffix,
          widget_menu_name: this.widget_menu_name,
          component_name: this.component_name,
          component_func: this.component_func,
          pending_params: this.pending_params,
          enable_date_picker: this.enable_date_picker,
          date_range_display: this.date_range_display,
          current_period_mode: this.current_period_mode,
        });
      }

      this.is_show_drawer = true;
      this.title_suffix = title_suffix || '';

      const is_same_component = this.component_name === component_name;

      if (!is_same_component) {
        this.widget_menu_name = '';
      }

      this.component_name = component_name;
      this.component_func = component_func;
      this.pending_params = component_params;

      this.enable_date_picker = !date_picker_exclude_components.includes(component_name);
      const initial_mode = component_params?.drilldown_period_mode || PERIOD_MODE_DAILY;
      this.current_period_mode = initial_mode;
      this.date_range_display = this.build_period_text(initial_mode, component_params);

      if (is_same_component && this.$refs.ref_component) {
        this.$nextTick(() => {
          this.trigger_component();
        });
      }
    },

    async trigger_component() {
      if(!this.$refs.ref_component) return;

      await this.with_loading(async() => {
        await this.$refs.ref_component?.[this.component_func]?.(this.pending_params);
      });
      this.sync_period_display();
    },
  }
};
</script>

<style scoped>
.side-drawer {
  border-radius: 8px 0 0 8px;
}

.drawer-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.drawer-header {
  flex: 0 0 auto;
  position: sticky;
  top: 0;
  z-index: 1;
}

.drawer-content {
  flex: 1;
  overflow-y: auto;
}

/* 返回按鈕樣式 */
.v-btn.back-button {
  background-color: #424242 !important;
  color: white !important;
  border-radius: 6px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3) !important;
  transition: all 0.2s ease;
  min-width: 36px !important;
  height: 36px !important;
  border: 1px solid #616161 !important;
}

.v-btn.back-button:hover {
  background-color: #616161 !important;
  border-color: #757575 !important;
  transform: translateX(-2px);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.4) !important;
}

.v-btn.back-button:active {
  background-color: #303030 !important;
  transform: translateX(0);
}

.v-btn.back-button span {
  color: white !important;
  font-size: 24px !important;
  font-weight: 900 !important;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.8);
}

/* 標題容器樣式 */
.title-wrapper {
  display: inline-block;
  max-width: 100%;
  vertical-align: middle;
}

.title-text {
  color: white;
  font-size: 1rem;
  font-weight: 500;
}

/* 手機模式下可滑動的標題 */
.title-scrollable {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  max-width: calc(100vw - 120px);
  margin-right: 8px;
}

/* 有返回按鈕時調整寬度 */
.title-scrollable.with-back-btn {
  max-width: calc(100vw - 160px);
}

/* 沒有日期選擇器時，標題可以更寬 */
.title-scrollable.no-date-picker {
  max-width: calc(100vw - 80px);
}

/* 有返回按鈕且沒有日期選擇器 */
.title-scrollable.with-back-btn.no-date-picker {
  max-width: calc(100vw - 120px);
}

.title-scrollable::-webkit-scrollbar {
  display: none;
}

.title-scrollable .title-text {
  white-space: nowrap;
  display: inline-block;
}

/* 矩形顯示型 chip（與快選 chip 視覺區分） */
.display-chip.v-chip {
  border-radius: 6px !important;
  height: 30px;
  font-weight: 500;
  letter-spacing: 0.2px;
  padding: 0 10px;
}

/* 手機模式日期 chip */
.mobile-date-chip {
  cursor: pointer !important;
  flex-shrink: 0 !important;
}

.mobile-date-chip:hover {
  opacity: 0.9 !important;
}
</style>
